import Vue from "vue";
import VueRouter from "vue-router";
import Rsvp from "./views/Rsvp.vue";
import Registry from "./views/Registry.vue";
import Schedule from "./views/Schedule.vue";
import Travel from "./views/Travel.vue";
import Login from "./views/Login.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

const routes = [
  {
    path: "/rsvp",
    name: "rsvp",
    components: { default: Rsvp, header: MainNavbar, footer: MainFooter },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    name: "schedule",
    components: { default: Schedule, header: MainNavbar, footer: MainFooter },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    components: { default: Login, header: MainNavbar, footer: MainFooter },
    props: {
      header: { colorOnScroll: 400 }
    }
  },
  {
    path: "/registry",
    name: "registry",
    components: { default: Registry, header: MainNavbar, footer: MainFooter },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/travel",
    name: "travel",
    components: { default: Travel, header: MainNavbar, footer: MainFooter },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    },
    meta: {
      requiresAuth: true
    }
  }
];

const router = new VueRouter({
  routes
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user;
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        user = data;
      }
      next(user)
    }).catch((e) => {
      next({
        path: '/login'
      }, e);
    });
  }
  next()
})

export default router
